@if (errorStore.isOpen()) {
  <div
    class="relative z-[9999]"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="errorStore.title()"
    (click)="onOverlayClick($event)"
  >
    <div
      class="fixed inset-0 bg-gray-500/75 transition-opacity"
      aria-hidden="true"
      (click)="$event.stopPropagation()"
    ></div>

    <div
      class="fixed inset-0 z-[10000] flex h-screen w-full items-center justify-center px-16 md:px-0"
    >
      <div
        class="flex flex-col items-center justify-center rounded-lg border bg-white px-4 py-8 shadow-2xl md:px-8 lg:px-24"
      >
        <p>
          <span
            class="material-icons text-cnfpc-error"
            style="font-size: 72px"
            >{{ errorStore.icon() }}</span
          >
        </p>
        <p
          class="text-cnfpc-logoGrayDark mt-4 text-2xl font-bold md:text-3xl lg:text-5xl"
        >
          {{ errorStore.title() }}
        </p>
        <p class="text-cnfpc-logoGrayLight mt-4 pb-4 text-center">
          {{ errorStore.message() }}
        </p>
        <div class="mt-6 flex items-center space-x-2">
          <app-cnfpc-button
            variant="secondary"
            icon="arrow_back"
            (onClick)="close()"
          >
            Retour vers l'accueil
          </app-cnfpc-button>
        </div>
      </div>
    </div>
  </div>
}
